export default function checkIOSSafari() {
  const ua = window.navigator.userAgent;
  return ua.indexOf('Safari') !== -1 && (ua.indexOf('iPhone') !== -1 || ua.indexOf('iPad') !== -1);
}
